<template>
  <div class="acomodar">

    <button class="btn btn-danger" style="align-self: flex-start; margin-left: 10px;  margin-top: 10px;" @click="$router.push(`/bienvenido`)">
      <i class="bi bi-skip-backward"></i>
    </button>¨

    <div class="acomodar1">
      <div class="header-titulo">
      <h2>PREGUNTAS FRECUENTES</h2>
    </div>

      <!-- Botones de Categorías -->
      <div class="botones-categorias">
        <button
            v-for="(categoria, index) in categorias"
            :key="index"
            @click="categoriaSeleccionada = categoria"
            :class="{ activo: categoriaSeleccionada === categoria }"
        >
          {{ categoria }}
        </button>
      </div>

      <!-- Preguntas Filtradas -->
      <div v-for="(faq, index) in preguntasFiltradas" :key="index" class="faq-container">
        <details class="faq-item" @toggle="evitarDesplazamiento($event)">
          <summary>{{ faq.pregunta }}</summary>
          <p v-if="Array.isArray(faq.respuesta)">
            <ul>
              <li v-for="(item, i) in faq.respuesta" :key="i">{{ item }}</li>
            </ul>
          </p>
          <p v-else>{{ faq.respuesta }}</p>
        </details>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PreFContratos",
  data() {
    return {
      categoriaSeleccionada: "",
      preguntas: [],
    };
  },
  computed: {
    categorias() {
      return [...new Set(this.preguntas.map((p) => p.categoria))];
    },
    preguntasFiltradas() {
      return this.preguntas.filter((faq) => faq.categoria === this.categoriaSeleccionada);
    },
  },
  methods: {
    evitarDesplazamiento(event) {
      if (event.target.open) {
        event.target.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    },
    cargarPreguntas() {
      this.axios
        .get("Dasboards/PreguntasFrecuentes")
        .then((response) => {
          console.log("Respuesta de la API PreguntasFrecuentes:", response.data);
          const datos = response.data;

          this.preguntas = datos.map(item => ({
            categoria: item.preCategoria,     // CORREGIDO
            pregunta: item.prePregunta,        // CORREGIDO
            respuesta: this.parsearRespuesta(item.preRespuesta), // CORREGIDO
          }));

          // Seleccionamos la primera categoría como activa
          if (this.preguntas.length > 0) {
            this.categoriaSeleccionada = this.preguntas[0].categoria;
          }
        })
        .catch((error) => {
          console.error("Error al cargar preguntas frecuentes:", error);
        });
    },
    parsearRespuesta(respuesta) {
      try {
        const parsed = JSON.parse(respuesta);
        return parsed;
      } catch (e) {
        return respuesta;
      }
    }
  },
  mounted() {
    this.cargarPreguntas();
  }
};
</script>


<style scoped>
/* Ajuste general */
.acomodar {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-top: 1%;
  margin-bottom: 1%;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left:1%;
  margin-right: 1%;
  height: auto;
  padding-bottom: 20px;
  border-radius: 10px 10px 10px 10px;
  overflow-x: hidden;
  overflow-y: none;
}

/* Ajuste del botón de regreso */
button {
  margin-top: 20px;
}

.acomodar2 {
  text-align: center;
  font-family: "Arial Black", sans-serif;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

/* Diseño de botones */
.botones-categorias {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-bottom: 20px;
  width: 100%;
}

.botones-categorias button {
  padding: 10px 15px;
  border: 2px solid blue;
  background-color: white;
  cursor: pointer;
  transition: 0.3s;
  font-size: 14px;
  border-radius: 5px;
}

.botones-categorias button:hover,
.activo {
  background-color: #1c4fdb;
  color: white;
}

/* Contenedor de cada pregunta */
.faq-container {
  width: 100%;
  margin-top: 15px;
  padding-left: 15px;
  padding-right: 15px;
}

/* Ajustes para evitar desplazamiento brusco */
.faq-item {
  width: 100%;
  border: 2px solid #1c4fdb;
  border-radius: 8px;
  padding: 16px;
  background-color: white;
  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
  overflow: hidden;
  max-height: 80px;
  opacity: 0.95;
  scroll-margin-top: 80px;
  font-size: 16px;
}

.faq-item[open] {
  max-height: 400px;
  opacity: 1;
}

/* Mejor visibilidad del título */
summary {
  cursor: pointer;
  font-size: 1.2em;
  font-weight: bold;
  color: #222;
  transition: color 0.3s;
}

summary:hover {
  color: #0e4dd6;
}

/* Estilo del texto de respuesta */
p {
  margin-top: 10px;
  font-size: 15px;
  color: #222;
}

ul {
  margin-top: 10px;
  padding-left: 20px;
}

li {
  margin-bottom: 5px;
  color: #222;
}

/* Diseño Responsivo */
@media (max-width: 768px) {
  .acomodar {
    padding: 15px;
  }

  .faq-item {
    font-size: 14px;
    padding: 12px;
  }

  summary {
    font-size: 1em;
  }

  p {
    font-size: 14px;
  }
}
.header-titulo {
  border: 1px solid #ccc;
  padding: 10px 20px;
  margin: 20px;
  text-align: center;
}
</style>



